import { DataGrid } from "@mui/x-data-grid";
import { PAGE_SIZE, ROW_HEIGHT } from "../constants/Constants";

export default function CustomDataGrid({ sx, ...props }) {
  return (
    <DataGrid
      pageSize={PAGE_SIZE}
      pageSizeOptions={[PAGE_SIZE]}
      disableRowSelectionOnClick
      disableColumnFilter
      paginationMode="server"
      rowHeight={ROW_HEIGHT}
      sx={{
        height: ROW_HEIGHT * PAGE_SIZE + 120,
        border: "none",
        "& .MuiDataGrid-menuIcon": {
          display: "none",
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          textTransform: "uppercase",
          fontWeight: 600,
          fontSize: "0.75rem",
          color: "rgba(58, 53, 65, 0.87)",
          whiteSpace: "wrap",
          lineHeight: 1,
        },
        "& .MuiDataGrid-cell--withRenderer": {
          display: "block",
          textOverflow: "unset",
        },
        "& .MuiDataGrid-cell--withRenderer span": {
          overflow: "hidden",
          textWrap: "nowrap",
          textOverflow: "ellipsis",
          display: "block",
        },
        "& .MuiDataGrid-columnsContainer": {
          backgroundColor: "rgb(249, 250, 252)",
          justifyContent: "center",
        },
        "& .MuiChip-root.a_error": {
          color: "rgb(97, 26, 21)",
          backgroundColor: "rgb(253, 236, 234)",
        },
        "& .MuiChip-root.b_modified": {
          color: "rgb(30, 70, 32)",
          backgroundColor: "rgb(237, 247, 237)",
        },
        "& .MuiChip-root.c_unmodified": {
          color: "rgb(13, 60, 97)",
          backgroundColor: "rgb(232, 244, 253)",
        },
        ...sx,
      }}
      {...props}
    />
  )
}